import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-status-pill',
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusPillComponent {
  @Input() status: any;
  @Input() label?: string;

  getStatusClass(): string {
    const s = this.status != null ? String(this.status).toUpperCase() : null;
    switch (s) {
      case 'CREATED':
        return 'status-warning';
      case 'IN_PROGRESS':
        return 'status-info';
      case 'FIXED':
        return 'status-success';
      case 'DEFERRED':
        return 'status-muted';
      case 'NOT_APPLICABLE':
        return 'status-muted';
      case 'PUSHED_BACK':
        return 'status-warning';
      default:
        return 'status-neutral';
    }
  }

  getIcon(): string {
    const s = this.status != null ? String(this.status).toUpperCase() : null;
    switch (s) {
      case 'CREATED':
        return 'report_problem';
      case 'IN_PROGRESS':
        return 'autorenew';
      case 'FIXED':
        return 'check_circle';
      case 'DEFERRED':
        return 'pause_circle';
      case 'NOT_APPLICABLE':
        return 'block';
      case 'PUSHED_BACK':
        return 'arrow_back';
      default:
        return 'info';
    }
  }

  getLabel(): string {
    if (this.label) return this.label;
    const s = this.status != null ? String(this.status).toUpperCase() : '';
    switch (s) {
      case 'CREATED':
        return 'Created';
      case 'IN_PROGRESS':
        return 'In progress';
      case 'FIXED':
        return 'Fixed';
      case 'DEFERRED':
        return 'Deferred';
      case 'NOT_APPLICABLE':
        return 'N/A';
      case 'PUSHED_BACK':
        return 'Pushed back';
      default:
        return s || '';
    }
  }
}
